import { ApolloError } from '@apollo/client'

const defaultErrorMessage = `Oops! Looks like something went wrong. Please try again or contact support.` // errorCode

// Backend error messages are formatted as "{code}: {message}" (e.g. "400_User_043: Security verification is required.")
// Strip the code prefix so users only see the human-readable message.
const errorCodePrefix = /^\d{3}_\w+_\d+:\s*/

function stripErrorCode(message: string): string {
	return message.replace(errorCodePrefix, '')
}

function messageOrDefault(message: string | undefined): string {
	return message ? stripErrorCode(message) : defaultErrorMessage
}

// The BE can return an ETag conflict even when the update succeeded (stale grain state race condition).
// Apollo surfaces this via networkError (data: null response), not graphQLErrors.
// Callers should suppress the error and treat the operation as successful.
export function isETagConflictError(error: ApolloError): boolean {
	const networkErrors: any[] = (error.networkError as any)?.result?.errors ?? []
	return networkErrors.some((e: any) => (e.extensions?.error_code as string | undefined)?.includes('ETag'))
}

export function trueErrorMessage(error: string | ApolloError | unknown) {
	console.error('Unexpected error', error)
	if (error instanceof ApolloError) {
		const trueErrorMessage = (error.networkError as any)?.result?.errors[0]?.message
		if (trueErrorMessage) {
			return trueErrorMessage
		}

		return messageOrDefault(error.message)
	}

	if (typeof error === 'object' && error !== null && 'message' in error) {
		return messageOrDefault((error as any).message)
	}

	if (typeof error === 'string') {
		return messageOrDefault(error)
	}

	return messageOrDefault(undefined)
}
